export const ADMIN_BASE_ROUTES = {
  CUSTOMER_NEW: '/admin/customer/',
  CUSTOMER: '/admin/customer/:customerId?',
  INSIGHTS: '/admin/insights',
  MESSAGES: '/admin/messages',
  SETTINGS: '/admin/settings',
};
